import Stack from "@mui/material/Stack";
import WorkgroupAvatar from "../WorkgroupCol/WorkgroupAvatar";
import Tooltip from "@mui/material/Tooltip";
import MDTypography from "../../../materialDashboard/components/MDTypography";
import React from "react";


const WorkgroupsCol = ({workgroups, align="center"}) => {
    const max = 2;
    const justify = align === "center" ? "center" : "flex-start";
    return <Stack direction="row" justifyContent={justify} alignItems="center">
        {workgroups?.slice(0, 2)?.map(workgroup => <WorkgroupAvatar key={workgroup.id} workgroup={workgroup} size="xs"/>)}

        {workgroups?.length > max && <Tooltip title={workgroups.slice(2).map(w=>w.name).join(", ")} placement="bottom" disableInteractive>
            <MDTypography variant="caption" ml={1}>+{workgroups.length - max}</MDTypography>
        </Tooltip>
        }
    </Stack>
}

export default WorkgroupsCol;